import { motion } from "framer-motion";
import { MessageCircle, ArrowUpRight } from "lucide-react";
import { DISCORD } from "../data/links";

const EASE = [0.16, 1, 0.3, 1];

export default function DiscordSection() {
  return (
    <section data-testid="discord-section" className="max-w-7xl mx-auto w-full px-4 sm:px-6 py-10 md:py-14">
      <motion.a
        data-testid="discord-link"
        href={DISCORD.url}
        target="_blank"
        rel="noopener noreferrer"
        className="group block border border-white/15 bg-white text-black hover:bg-black hover:text-white transition-colors duration-200 p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
      >
        <div className="flex items-center gap-5">
          <MessageCircle className="w-9 h-9 md:w-11 md:h-11 shrink-0" strokeWidth={1.5} />
          <div>
            <p className="font-sync text-[10px] tracking-[0.3em] uppercase opacity-60">{DISCORD.label}</p>
            <h2 className="font-gothic text-4xl md:text-6xl leading-none mt-1">Discord</h2>
            <p className="font-mono-t text-sm tracking-[0.15em] opacity-60 mt-1">{DISCORD.note}</p>
          </div>
        </div>
        <div className="flex items-center gap-4 self-start md:self-center">
          <span className="font-sync text-xs tracking-[0.3em] uppercase">JOIN</span>
          <span className="w-12 h-12 border border-current flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors duration-200">
            <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-200" strokeWidth={1.5} />
          </span>
        </div>
      </motion.a>
    </section>
  );
}
